import {
  differenceInHours,
  differenceInMinutes,
  format,
  isValid,
} from "date-fns"

export const MENU_NOTIFICATIONS_INTIAL_QUERY_STATE = {
  Read: false,
  skipCount: 0,
  maxResultCount: 10,
}

export const NOTIFICATION_INFO = [
  { type: "Albarán", path: "/documentos/albaranes", icon: "fa-file-contract" },
  { type: "Factura", path: "/documentos/facturas", icon: "fa-file-invoice" },
  { type: "Pedido", path: "/documentos/pedidos", icon: "fa-file-lines" },
  { type: "Presupuesto", path: "/documentos/presupuestos", icon: "fa-file" },
]

export const getValueByTitle = (
  notification = {},
  title: $TSMigrationFixMe
) => {
  // @ts-expect-error TS(2339): Property 'message' does not exist on type '{}'.
  const message = JSON.parse(notification.message)
  return message?.Items?.find((item: $TSMigrationFixMe) => item.Title === title)
    ?.Value
}

const mapNotificationDate = (date: $TSMigrationFixMe) => {
  if (!isValid(new Date(date))) return ""

  const distanceInMinutes = differenceInMinutes(new Date(), new Date(date))
  const distanceInHours = differenceInHours(new Date(), new Date(date))

  if (distanceInMinutes < 1) return "Ahora"

  if (distanceInMinutes === 1) return "Hace 1 minuto"

  if (distanceInMinutes < 60) return `Hace ${distanceInMinutes} minutos`

  if (distanceInHours === 1) return `Hace 1 hora`

  if (distanceInHours <= 24) return `Hace ${distanceInHours} horas`

  return `${format(new Date(date), "dd/MM/yyyy")} - ${format(
    new Date(date),
    "HH:mm"
  )}`
}

export const newNotificationMessage = (message: $TSMigrationFixMe) => {
  const notification = { message }
  // TODO: i18n
  const emisora = getValueByTitle(notification, "Empresa emisora")
  const receptora = getValueByTitle(notification, "Empresa receptora")
  const tipo = getValueByTitle(notification, "Documento tipo")
  const importe = getValueByTitle(notification, "Importe")

  return `${emisora} te ha enviado un documento - ${tipo} de ${importe} a ${receptora}`
}

export const notificationMessage = (
  notification: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  const emisora = (
    <span className='notification-menu-title'>
      {getValueByTitle(notification, "Empresa emisora")}
    </span>
  )

  const receptora = (
    <span className='notification-menu-empresa-receptora'>
      {getValueByTitle(notification, "Empresa receptora")}
    </span>
  )
  const tipo = (
    <span className='notification-menu-title'>
      {getValueByTitle(notification, "Documento tipo")}
    </span>
  )

  const importe = (
    <span className='notification-menu-title'>
      {getValueByTitle(notification, "Importe")}
    </span>
  )

  const date = (
    <span className='notification-menu-date'>
      {mapNotificationDate(notification.creationTime)}
    </span>
  )

  return (
    <>
      <div>
        {emisora} {`${t("notificationsMenu.card.sendDocument")}`} - {tipo}
        {getValueByTitle(notification, "Importe") ? (
          <>
            {" "}
            {`${t("notificationsMenu.card.de")}`} {importe}
          </>
        ) : (
          ""
        )}
      </div>
      <div>
        {date} - {receptora}
      </div>
    </>
  )
}

export const getNotifiactionInfo = (type: $TSMigrationFixMe) =>
  NOTIFICATION_INFO.find((n) => n.type === type)
